const alternatifCode = {
    "js":"// Hii!\n// Just try 19Code!\n// Made with 💙 by Prosper19",
    "cpp":"// Hii!\n// Just try 19Code!\n// Made with 💙 by Prosper19",
    "c":"// Hii!\n// Just try 19Code!\n// Made with 💙 by Prosper19",
    "py":"# Hii!\n# Just try 19Code!\n# Made with 💙 by Prosper19",
}

export default alternatifCode;